/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCouponPolicyList
// ====================================================

export interface GetCouponPolicyList_coupon_policy_list_item_list {
  /**
   * user_account_coupon_policy id
   */
  id: string;
  /**
   * 쿠폰 TARGET TYPE
   */
  coupon_target_type: CouponTargetType;
  /**
   * 쿠폰 적용 가능 상품 배송 타입 (직진 배송 / 일반 배송)
   */
  delivery_type: CouponDeliveryType | null;
  /**
   * 쿠폰 title
   */
  title: string;
  /**
   * 쿠폰 설명
   */
  description: string | null;
  /**
   * 응답 포맷 적용된 쿠폰 등록 종료일
   */
  date_issue_end_with_format: string;
  /**
   * 쿠폰 발급 유저 타입
   */
  registration_type: CouponRegistrationType;
  /**
   * 쿠폰 다운로드 가능 상태
   */
  download_status: UserAccountCouponStatus;
  /**
   * 쿠폰 정책 생성일
   */
  date_created: CrTimestamp;
  /**
   * 쿠폰 등록 종료일
   */
  date_issue_end: CrTimestamp;
  /**
   * 쿠폰을 사용할 수 있는 최소 금액
   */
  min_required_amount: number | null;
  /**
   * 쿠폰이 최대로 할인해줄수있는 금액
   */
  max_discount_amount: number | null;
  /**
   * 쿠폰 할인 금액
   */
  discount_amount: number | null;
  /**
   * 쿠폰 할인률
   */
  discount_rate_bp: number | null;
  /**
   * Z-Only 대표샵 쿠폰 여부
   */
  is_zonly_store_coupon: boolean;
  /**
   * 쿠폰 정책 사용 가능 플랫폼 타입
   */
  platform: PolicyPlatform;
  /**
   * 적용된 페널티 그룹 ID
   */
  penalty_group_id: string | null;
  /**
   * 유저당 사용 가능한 횟수(무제한 : -1, 기본값 1)
   */
  repeatable_use_count: number;
  /**
   * 쿠폰적용 회차정보 (1차 쿠폰 : 0 , 2차 쿠폰 : 1)
   */
  priority: number;
  /**
   * 뱃지 리스트
   */
  badge_list: string[];
}

export interface GetCouponPolicyList_coupon_policy_list {
  item_list: GetCouponPolicyList_coupon_policy_list_item_list[];
}

export interface GetCouponPolicyList {
  /**
   * 쿠폰 정책 목록을 조회한다.
   */
  coupon_policy_list: GetCouponPolicyList_coupon_policy_list;
}

export interface GetCouponPolicyListVariables {
  product_id_list?: string[] | null;
  shop_id_list?: string[] | null;
  coupon_registration_type_list?: CouponRegistrationType[] | null;
  coupon_code_type_list?: CouponCodeType[] | null;
  include_zonly?: boolean | null;
  coupon_target_type_list?: CouponTargetType[] | null;
  issue_status?: UserAccountCouponPolicyIssueStatus | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * 쿠폰 Code TYPE
 */
export enum CouponCodeType {
  EVENT = "EVENT",
  GENERAL = "GENERAL",
  NONE = "NONE",
  REDEEM = "REDEEM",
  UNIQUE = "UNIQUE",
}

/**
 * 쿠폰 적용 가능 상품 배송 타입
 */
export enum CouponDeliveryType {
  NORMAL = "NORMAL",
  ZONLY = "ZONLY",
}

/**
 * 쿠폰 발급 유저 타입
 */
export enum CouponRegistrationType {
  BOOKMARK = "BOOKMARK",
  GENERAL = "GENERAL",
  INACTIVE_ACCOUNT = "INACTIVE_ACCOUNT",
  MEMBERSHIP = "MEMBERSHIP",
  MESSAGE = "MESSAGE",
  NEW = "NEW",
  REFERER_NAVER = "REFERER_NAVER",
  REPURCHASE = "REPURCHASE",
  REVIEW = "REVIEW",
  STORY = "STORY",
  TARGETING = "TARGETING",
}

export enum CouponTargetType {
  CATEGORY = "CATEGORY",
  DEPARTMENT = "DEPARTMENT",
  ORDER = "ORDER",
  ORDER_ITEM = "ORDER_ITEM",
  ORDER_ITEM_GROUP = "ORDER_ITEM_GROUP",
  POINT = "POINT",
  SHIPPING_FEE = "SHIPPING_FEE",
  SHOP = "SHOP",
  SHOP_GROUP = "SHOP_GROUP",
  SHOP_GROUP_JUST_ZONLY = "SHOP_GROUP_JUST_ZONLY",
  SHOP_GROUP_WITH_ZONLY = "SHOP_GROUP_WITH_ZONLY",
  SHOP_SHIPPING_FEE = "SHOP_SHIPPING_FEE",
  SHOP_WITH_ZONLY = "SHOP_WITH_ZONLY",
}

/**
 * 정책 플랫폼 타입
 */
export enum PolicyPlatform {
  ALL = "ALL",
  APP = "APP",
  WEB = "WEB",
}

/**
 * 쿠폰 정책 발급 상태
 */
export enum UserAccountCouponPolicyIssueStatus {
  ISSUE_COMPLETED = "ISSUE_COMPLETED",
  ISSUE_STOPPED = "ISSUE_STOPPED",
  ISSUE_WAITING = "ISSUE_WAITING",
  ISSUING = "ISSUING",
}

/**
 * 쿠폰 상태
 */
export enum UserAccountCouponStatus {
  EXPIRED = "EXPIRED",
  ISSUABLE = "ISSUABLE",
  ISSUEABLE = "ISSUEABLE",
  ISSUED = "ISSUED",
  UNISSUABLE = "UNISSUABLE",
  USED = "USED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
